const version =
  (typeof document !== 'undefined' &&
    document.documentElement &&
    document.documentElement.dataset &&
    document.documentElement.dataset.version) ||
  '';

export default function getAppVersion() {
  return version;
}
